module.exports = __webpack_public_path__ + "img/loading.5988858b.png";